import { Float } from '@headlessui-float/react'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import React from 'react'
import { LocaleEnum, localeNames } from '@systemeio/ui-frontend'
import { useTranslation } from 'next-i18next'
import { useFloatHover } from 'shared/hooks/use-float-hover'
import { useLanguageSwitcher } from 'shared/hooks/use-language-switcher'
import ChevronDownIcon from 'shared/icons/chevron-down-icon'
import { getCalculatedLanguage } from 'shared/utils/get-calculated-language'

const PublicLanguageSwitcher = ({ mobile }: { mobile?: boolean }) => {
  const { i18n } = useTranslation()
  const { show, delayClose, delayOpen, close, open } = useFloatHover()
  const { handleChangeLanguage, isChangingLanguage } = useLanguageSwitcher()

  if (!i18n) {
    return <div>loading...</div>
  }
  return (
    <Popover className={'h-full font-mulish'}>
      <Float
        show={show}
        offset={10}
        portal
        autoPlacement={{ allowedPlacements: ['bottom', 'bottom-end', 'bottom-end', 'top'] }}
        arrow
        enter="transition duration-100 ease-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition duration-75 ease-in"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className={'flex h-full items-center'}
      >
        <PopoverButton
          onMouseEnter={mobile ? () => {} : delayOpen}
          onMouseLeave={mobile ? () => {} : delayClose}
          onClick={mobile ? (show ? close : open) : () => {}}
          disabled={isChangingLanguage}
          className={`flex size-fit items-center justify-around gap-2.5 focus:outline-none ${
            isChangingLanguage && 'animate-pulse'
          }`}
        >
          <div className="w-5 text-sm font-bold text-brand-primary">
            {getCalculatedLanguage(i18n?.language)}
          </div>
          <ChevronDownIcon />
        </PopoverButton>

        <PopoverPanel
          onMouseEnter={mobile ? () => {} : delayOpen}
          onMouseLeave={mobile ? () => {} : delayClose}
          className={`flex flex-col rounded-lg bg-background-secondary text-sm shadow-lg ${
            isChangingLanguage ? 'pointer-events-none' : ''
          }`}
        >
          <Float.Arrow className={`absolute size-4 rotate-45 bg-background-secondary`} />
          <ul className={'flex flex-col whitespace-nowrap py-4 text-sm'}>
            {Object.keys(localeNames).map(locale => (
              <li key={locale}>
                <button
                  className={`main-transition-colors w-full cursor-pointer px-7 py-1 text-start hover:text-brand-primary focus:outline-none focus-visible:text-brand-primary ${
                    locale === i18n.language ? 'text-brand-primary' : 'text-text-tertiary'
                  }`}
                >
                  <p
                    onClick={() => {
                      close()
                      handleChangeLanguage(locale as LocaleEnum)
                    }}
                  >
                    {localeNames[locale as LocaleEnum]}
                  </p>
                </button>
              </li>
            ))}
          </ul>
        </PopoverPanel>
      </Float>
    </Popover>
  )
}

export default PublicLanguageSwitcher
